import { type ProgramTaskId, type UnsavedProgramTask } from '@terros/common'
import { type FormExpirationOption } from './expiration'

export type FormProgramTask = Omit<UnsavedProgramTask, 'type' | 'duration' | 'expiration' | 'openSince'> & {
  type: FormTaskType
  duration: TaskFormDuration
  expiration: TaskFormExpiration
  /** HH:mm */
  openSince?: string
}

export type TaskFormResult = {
  tasks: UnsavedProgramTask[]
  changedTaskIndex: number
}

export type TaskFormDuration = {
  type: ProgramTaskDurationOption
  days: number
  /** HH:mm */
  time: string
}

export type TaskFormExpiration = {
  type: FormExpirationOption
  enabled: boolean
  days: number
  /** HH:mm */
  time: string
}

export type ProgramTaskDurationOption = 'endOfDay' | 'nextDay' | 'week' | 'custom' | 'none'

export const FORM_TASK_TYPES = [
  'CreateAccount',
  'Custom',
  'ExternalLink',
  'PitchProspect',
  'TakeQuiz',
  'RecordEvaluation',
  'SalesOutput',
  'SalesPlanning',
  'SendMessage',
  'Shadowing',
  'RecordConversation',
  'WatchVideo',
  'WorkflowStage',
  'WorkflowAction',
] as const
export const isFormTaskType = (type: string): type is FormTaskType => FORM_TASK_TYPES.some((t) => t === type)
export type FormTaskType = (typeof FORM_TASK_TYPES)[number]
